import DECISIONTYPES from '../constants/fbsDecisionLabelTypeConstants';
import type { FbsDecision } from '../types/FbsDecision';
import { formatCurrency } from './formatters';

type DecisionLabelProps = {
  fbsDecision: FbsDecision;
  downPayment: number;
};

type DecisionLabelReturnType = {
  hasTerms: boolean;
  text: string;
  subText?: string;
  type: string;
};

export default {
  approved: ({
    fbsDecision,
    downPayment,
  }: DecisionLabelProps): DecisionLabelReturnType => {
    const carMonthlyPayment =
      fbsDecision.terms[0]?.maxTermRate?.monthlyPayment || 0;
    if (carMonthlyPayment === 0) {
      return {
        text: 'Buy without financing',
        subText: 'Your down payment exceeds our no-haggle price.',
        type: DECISIONTYPES.notNeeded,
        hasTerms: false,
      };
    }

    return {
      text: `Pre-qualified with ${formatCurrency(fbsDecision.conditionAmountRounded + downPayment)} down`,
      subText: undefined,
      type: DECISIONTYPES.preApproved,
      hasTerms: true,
    };
  },
  countered: ({
    fbsDecision,
    downPayment,
  }: DecisionLabelProps): DecisionLabelReturnType => {
    if (
      fbsDecision &&
      fbsDecision.lenderName === 'Cash' &&
      fbsDecision.totalFinanceAmount === 0
    ) {
      /* TODO: This is a temporary way of determining vehicles where pre-approval is unavailable.
        FBS will be making a change to determine it on their side and pass a different status instead.
        10/14/2025 - Checked with Josh Bradley and these are still needed for now
      */
      return {
        text: `Pre-qualification unavailable on this car`,
        subText:
          "We weren't able to pre-approve you for financing at this time.",
        type: DECISIONTYPES.declined,
        hasTerms: false,
      };
    }

    return {
      text: `Pre-qualified with ${formatCurrency(fbsDecision?.conditionAmountRounded + downPayment)} down`,
      subText: undefined,
      type: DECISIONTYPES.additionalDown,
      hasTerms: true,
    };
  },
  declined: (): DecisionLabelReturnType => {
    return {
      text: `Pre-qualification unavailable on this car`,
      subText: "We weren't able to pre-approve you for financing at this time.",
      type: DECISIONTYPES.declined,
      hasTerms: false,
    };
  },
  default: (): DecisionLabelReturnType => ({
    text: 'Information unavailable',
    subText: 'A technical error occurred on our end. Check back later.',
    type: DECISIONTYPES.noInfo,
    hasTerms: false,
  }),
};
